<template>
</template>

<script>
// import Object3d from '@/plugins/Dom3d/mixin'
import { ToCanvas } from '@/utils/ToCanvas'
import gsap from 'gsap'
import { webGL } from '@/webGL/WebGL'

import {
  CanvasTexture,
  MeshPhongMaterial,
  MeshBasicMaterial,
  PlaneBufferGeometry,
  Mesh,
  LinearMipmapNearestFilter,
  NearestFilter,
  RGBAFormat,
  FloatType,
  UVMapping,
  ClampToEdgeWrapping
} from 'three'

const canvasWidth = 1920
const canvasHeight = 1080

export default {
  // mixins: [Object3d],

  props: {
    slides: {
      type: Array,
      default: () => {return []}
    },
    currentIndex: {
      type: Number,
      default: -1
    }
  },

  created () {
    this.progress = 0
  },

  mounted () {
    this.initSlides()
    this.smoothProgress = this.currentIndex

    this.canvas = document.createElement('canvas')
    this.canvas.width = canvasWidth
    this.canvas.height = canvasHeight
    this.ctx = this.canvas.getContext('2d')

    this.canvas.style.position = 'absolute'
    this.canvas.style.top = '50px'
    this.canvas.style.zIndex = 100
    this.canvas.style.width = '100px'
    // document.body.appendChild(this.canvas)

    // CanvasTexture( canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy )
    this.texture = new CanvasTexture(this.canvas, UVMapping, ClampToEdgeWrapping, ClampToEdgeWrapping, NearestFilter, LinearMipmapNearestFilter, RGBAFormat, FloatType)

    const screenSize = 250
    this.geometry = new PlaneBufferGeometry(1.77 * screenSize, 1 * screenSize)
    this.material = new MeshBasicMaterial({
      map: this.texture
    })

    this.screen = new Mesh(this.geometry, this.material)
    this.screen.name = 'screen'
    this.screen.position.set(0, (screenSize * .5) + 43, -2.4)
    this.screen.rotation.y = -0.349066
    this.screen.rotation.y = -0.36

    this.$hub.on('player:play', () => {
      if (this.slides[this.currentIndex] && this.slides[this.currentIndex].toCanvas && this.slides[this.currentIndex].toCanvas.video) {
        this.slides[this.currentIndex].toCanvas.play()
      }
    })
    this.$hub.on('player:pause', () => {
      if (this.slides[this.currentIndex] && this.slides[this.currentIndex].toCanvas && this.slides[this.currentIndex].toCanvas.video) {
        this.slides[this.currentIndex].toCanvas.pause()
      }
    })

    webGL.sceneScreen.add(this.screen)
  },

  destroy () {
    webGL.sceneScreen.remove(this.screen)
    this.texture.dispose()
    this.material.dispose()
    this.geometry.dispose()
  },

  methods: {
    onUpdate () {
      this.slides.forEach((slide, index) => {
        const dist = index - this.progress

        if (Math.abs(dist) < 1 && slide.toCanvas) {
          this.ctx.drawImage(slide.toCanvas.canvas, dist * canvasWidth, 0, canvasWidth, canvasHeight)
        }
      })

      this.texture.needsUpdate = true
    },

    initSlides () {
      this.slides.forEach((slide, index) => {
        if (slide.media[0].url.toLowerCase().endsWith('.mp4')) {
          slide.toCanvas = new ToCanvas({
            video: slide.media[0].url,
            width: canvasWidth,
            height: canvasHeight
          })
        }
        else {
          slide.toCanvas = new ToCanvas({
            image: slide.media[0].url,
            width: canvasWidth,
            height: canvasHeight
          })
        }
      })
    }
  },
  watch: {
    currentIndex (to, from) {
      if (this.slides[from] && this.slides[from].toCanvas && this.slides[from].toCanvas.video) {
        this.slides[from].toCanvas.pause()
      }

      gsap.to(this, {
        progress: this.currentIndex,
        duration: 1
      })

      if (this.slides[this.currentIndex].toCanvas && this.slides[this.currentIndex].toCanvas.video) {
        this.slides[this.currentIndex].toCanvas.start().then(() => {
          this.$emit('onNext')
        })
      }
      else {
        this.$emit('onNext')
      }
    }
  } 
}
</script>

<style lang="stylus">
@import '~@/styles/settings/easings'

.slider
  &__slide
    transition transform .5s ease-in-out-quad
</style>